const sites = {
    main: 'https://www.visualcron.com',
    admin: 'https://admin.visualcron.com'
};

export default sites; 